// Indian numbering + currency helpers

export function formatINR(n, { compact = false } = {}) {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  const num = Math.round(Number(n));
  if (compact) {
    const abs = Math.abs(num);
    if (abs >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (abs >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
    if (abs >= 1000) return `₹${(num / 1000).toFixed(1)}k`;
    return `₹${num}`;
  }
  return "₹" + indianGroup(num);
}

export function indianGroup(num) {
  const neg = num < 0;
  let s = String(Math.abs(num));
  let result;
  if (s.length <= 3) {
    result = s;
  } else {
    const last3 = s.slice(-3);
    let rest = s.slice(0, -3);
    const parts = [];
    while (rest.length > 2) {
      parts.unshift(rest.slice(-2));
      rest = rest.slice(0, -2);
    }
    if (rest) parts.unshift(rest);
    result = parts.join(",") + "," + last3;
  }
  return (neg ? "-" : "") + result;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "—";
  }
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return "just now";
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
}
